import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import {captureException} from '@zzng/common/utils/matrix';

export const DATE_TIME_REGEX = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?/;
export const DATE_REGEX = /\d{4}-\d{2}-\d{2}(?!T)/;
export const CARD_INFO_PERIOD_FORMAT = 'YYYY. M. D. HH:mm';

dayjs.extend(customParseFormat);
dayjs.locale('ko');

/** yyyy-mm-dd인지 확인 */
export const checkDateFormat = (date: string) => {
  return DATE_REGEX.test(date.trim());
};

/** yyyy-mm-ddTHH:mm:ss인지 확인 */
export const checkDateTimeFormat = (date: string) => {
  return DATE_TIME_REGEX.test(date.trim());
};

/** YYYY. M. D. HH:mm */
export const getDateTimeFormat = (date?: string) => {
  if (!date) return '';
  return dayjs(date).format('YYYY. M. D. HH:mm');
};

/** YYYY. M. D */
export const getDateFormat = (date?: string) => {
  if (!date) return '';

  return dayjs(date).format('YYYY. M. D');
};

/** yyyy-mm-dd ~ yyyy-mm-dd */
export const mergeDateFormat = ({start = '', end = ''}: {start?: string; end?: string}): `${string} ~ ${string}` => {
  if (!checkDateFormat(start)) {
    captureException(`시작 날짜 형식이 올바르지 않습니다. date: ${start}`);
  }

  if (!checkDateFormat(end)) {
    captureException(`종료 날짜 형식이 올바르지 않습니다. date: ${end}`);
  }

  return `${start} ~ ${end}`;
};

/** 현재 날짜 기준 만료 여부 확인 */
export const isExpired = (date?: string | null, format?: string): date is string => {
  if (!date) return false;

  // NOTE: iOS의 경우 정확한 format을 지정하지 않으면 정상동작 하지 않음
  const parsedDate = dayjs(date, format, true);

  if (!parsedDate.isValid()) {
    captureException(`Invalid date format(${format}): ${date}`);
    return false;
  }

  return parsedDate.isBefore(dayjs());
};
